const KEY = 'appHistory'

export const historyStorage = {
    get() {
        try {
            return JSON.parse(sessionStorage.getItem(KEY) || '[]')
        } catch {
            return []
        }
    },
    set(history) {
        sessionStorage.setItem(KEY, JSON.stringify(history))
    },
    clear() {
        sessionStorage.removeItem(KEY)
    }
}